import { useAppSelector } from 'app/hooks';
import { selectUserLogged } from 'features/common/commonSelectors';
import { selectUserData } from 'features/userDetail/userDetailSelector';
import { useUserDetailContext } from 'features/userDetail/context/userDetailContext';
import { QuickSelectionType } from './usePatientQuickSelections';

/**
 * Enlace a la configuración de la lista de selección rápida desde un formulario del paciente: la pestaña del
 * grupo del paciente (donde se ven también las heredadas) y la sección del tipo. Solo para admin/superadmin, que
 * son quienes pueden editarla; para el resto devuelve undefined y no se pinta el engranaje.
 */
export const useQuickSelectionSettingsHref = (
  type: QuickSelectionType | 'HEALTH_SERVICE' | 'GENERAL_CONTACT',
): string | undefined => {
  const contextKey = useUserDetailContext();
  const userLogged: any = useAppSelector(selectUserLogged);
  const patient: any = useAppSelector((state) => selectUserData(state, contextKey));

  const isAdmin = userLogged?.access === 'ADMINISTRATOR' || userLogged?.access === 'SUPERADMINISTRATOR';
  const groupId = patient?.group?.id;
  if (!isAdmin || !groupId) return undefined;

  if (type === 'HEALTH_SERVICE') return `/groups/${groupId}?tab=healthServices`;
  if (type === 'GENERAL_CONTACT') return `/groups/${groupId}?tab=generalContacts`;
  return `/groups/${groupId}?tab=quickSelections#quick-selection-${type}`;
};
